import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatStoredDate } from "@/lib/date";

export const formatChartDate = (value) =>
  formatStoredDate(value, { month: "short", day: "numeric" });

const fetchSummary = async (period) => {
  const query = period === "all" ? "" : `?period=${period}`;
  const response = await api.get(`/summary${query}`);
  return response.data;
};

const toChartData = (chartPoints = []) =>
  chartPoints.map((point) => ({
    ...point.ratings,
    average: point.average,
    label: formatChartDate(point.label),
    period: point.period,
  }));

export const useDashboardData = (period) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const loadSummary = async () => {
      setLoading(true);
      setError("");
      try {
        const nextSummary = await fetchSummary(period);
        if (isMounted) setSummary(nextSummary);
      } catch {
        if (!isMounted) return;
        setError("Unable to load your summary right now. Please try again shortly.");
        setSummary(null);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadSummary();
    return () => {
      isMounted = false;
    };
  }, [period]);

  const chartData = toChartData(summary?.chart_points);

  return { chartData, error, loading, summary };
};